import React, { useContext } from 'react';
import { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { ProfileContext } from '../contexts/ProfileContext';
import BadgeButton from './buttons/BadgeButton';

const Header = () => {
  const [menuOpened, setMenuOpened] = useState(false);
  const { logout } = useContext(AuthContext);
  const { profile, notifications } = useContext(ProfileContext);
  const history = useHistory();

  const handleLogout = async () => {
    history.push("/pre-logout/");
  }

  const handleClickMenu = (e) => {
    e.preventDefault();
    setMenuOpened(!menuOpened);
  }

  return (
    <nav 
      className="navbar" 
      id="header"
      style={{
        backgroundColor: '#ffffff',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
      }}
    >
      <div className="navbar-brand">
        <Link 
          to="/" 
          className="navbar-item"
          style={{
            transition: 'all 0.2s ease',
          }}
        >
          <img 
            className="image" 
            src="/assets/images/radiopolis2.png" 
            alt="logo" 
            width="128" 
            height="128"
            style={{
              transition: 'all 0.2s ease',
            }}
          />
        </Link>
        
        <a 
          role="button" 
          className={`navbar-burger ${menuOpened ? 'is-active' : ''}`} 
          aria-label="menu" 
          aria-expanded="false" 
          onClick={(e) => handleClickMenu(e)}
          style={{
            transition: 'all 0.2s ease',
            borderRadius: '6px',
          }}
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      
      <div className={`navbar-menu ${menuOpened ? 'is-active' : ''}`}>
        <div className="navbar-start">
          <Link 
            to="/" 
            className="navbar-item has-text-weight-medium"
            style={{
              transition: 'all 0.2s ease',
              borderRadius: '6px',
              margin: '0 0.25rem',
            }}
          >
            <span className="icon-text">
              <span className="icon is-small mr-2">
                <i className="fa fa-file"></i>
              </span>
              <span>Órdenes</span>
            </span>
          </Link>
          
          <Link 
            to="/facturas" 
            className="navbar-item has-text-weight-medium"
            style={{
              transition: 'all 0.2s ease',
              borderRadius: '6px',
              margin: '0 0.25rem',
            }}
          >
            <span className="icon-text">
              <span className="icon is-small mr-2">
                <i className="fa fa-file-invoice"></i>
              </span>
              <span>Facturas</span>
            </span>
          </Link>
          
          {profile?.is_admin && (
            <Link 
              to="/admin" 
              className="navbar-item has-text-weight-medium"
              style={{
                transition: 'all 0.2s ease',
                borderRadius: '6px',
                margin: '0 0.25rem',
              }}
            >
              <span className="icon-text">
                <span className="icon is-small mr-2">
                  <i className="fa fa-cogs"></i>
                </span>
                <span>Admin</span>
              </span>
            </Link>
          )}
          
          {profile?.is_admin && (
            <Link 
              to="/auditoria" 
              className="navbar-item has-text-weight-medium"
              style={{
                transition: 'all 0.2s ease',
                borderRadius: '6px',
                margin: '0 0.25rem',
              }}
            >
              <span className="icon-text">
                <span className="icon is-small mr-2">
                  <i className="fa fa-search"></i>
                </span>
                <span>Auditoría</span>
              </span>
            </Link>
          )}
        </div>
      </div>

      <div className="navbar-end">
        {!profile?.is_admin && (
          <div className="navbar-item">
            <BadgeButton 
              name="Notificaciones" 
              link={'/mis-notificaciones'} 
              number={notifications.length} 
            />
          </div>
        )}
        
        <div className="navbar-item">
          <button 
            onClick={handleLogout} 
            className="button is-light is-rounded"
            style={{
              transition: 'all 0.2s ease',
              fontWeight: '500',
            }}
          >
            <span className="icon is-small mr-2">
              <i className="fa fa-sign-out-alt"></i>
            </span>
            <span>Salir</span>
          </button>
        </div>
        
        <div className="navbar-item">
          <button 
            disabled 
            className="button is-primary is-rounded"
            style={{
              fontWeight: '500',
              cursor: 'default',
            }}
          >
            <span className="icon is-small mr-2">
              <i className="fas fa-user"></i>
            </span>
            <span>{profile?.user?.username}</span>
          </button>
        </div>
      </div>

      {/* ✅ ESTILOS CSS ADICIONALES */}
      <style jsx>{`
        .navbar-item:hover {
          background-color: rgba(50, 115, 220, 0.1);
          color: #3273dc;
        }

        .navbar-item.is-active {
          background-color: rgba(50, 115, 220, 0.15);
          color: #3273dc;
        }

        .button:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
        }

        .button.is-light:hover {
          background-color: #f5f5f5;
        }

        .button.is-primary:disabled {
          opacity: 1;
          background-color: #3273dc;
          border-color: #3273dc;
          color: white;
        }

        .navbar-burger:hover {
          background-color: rgba(0, 0, 0, 0.05);
        }

        .navbar-brand .navbar-item:hover img {
          transform: scale(1.05);
        }

        .icon-text {
          align-items: center;
        }

        /* Responsive improvements */
        @media screen and (max-width: 1023px) {
          .navbar-menu {
            box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
            border-radius: 0 0 8px 8px;
          }
          
          .navbar-item {
            padding: 0.75rem 1rem;
          }
        }

        /* Active link styling */
        .navbar-item.router-link-active {
          background-color: rgba(50, 115, 220, 0.1);
          color: #3273dc;
          border-bottom: 2px solid #3273dc;
        }

        /* Focus states for accessibility */
        .navbar-item:focus,
        .button:focus {
          box-shadow: 0 0 0 3px rgba(50, 115, 220, 0.25);
        }
      `}</style>
    </nav>
  );
};

export default Header;